var _title, _defs, _g;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgLatency = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "280px",
    height: "56px",
    viewBox: "0 0 280 56",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "feature/latency/image")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter-1"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    type: "matrix",
    values: "0 0 0 0 0.000000 0 0 0 0 0.513725 0 0 0 0 0.560784 0 0 0 1.000000 0"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter-2"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    type: "matrix",
    values: "0 0 0 0 0.309804 0 0 0 0 0.701961 0 0 0 0 0.749020 0 0 0 1.000000 0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "100%",
    y1: "50%",
    x2: "0%",
    y2: "50%",
    id: "linearGradient-3"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00838F",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4FB3BF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "100%",
    y1: "50%",
    x2: "0%",
    y2: "50%",
    id: "linearGradient-4"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00838F",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4FB3BF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-5"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00838F",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4FB3BF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "path-6",
    cx: 140,
    cy: 28,
    r: 12
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "feature/latency/image",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon/record/gray/2",
    transform: "translate(255.000000, 20.000000)",
    filter: "url(#filter-1)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M8.11711696,10.1051991 C8.78651749,10.1057065 9.42852303,9.83943395 9.90106004,9.36530408 C10.3735971,8.89117421 10.6377018,8.24828211 10.6349289,7.57889751 L10.6434553,2.52629917 C10.6434553,1.13106266 9.5123751,0 8.11711696,0 C6.72185882,0 5.59077622,1.13106266 5.59077622,2.52629917 L5.59077622,7.57889751 C5.58985503,8.24919641 5.85572546,8.89230724 6.32970616,9.36628059 C6.80368686,9.84025394 7.44680766,10.1061202 8.11711696,10.1051991 L8.11711696,10.1051991 Z M12.5802094,7.57889751 C12.5802094,10.1051967 10.4413482,11.8736061 8.11711696,11.8736061 C5.79288568,11.8736061 3.65370869,10.1051967 3.65370869,7.57889751 L2.22222222,7.57889751 C2.22222222,10.4588786 4.51266373,12.8250735 7.27489891,13.2378076 L7.27489891,16 L8.95901921,16 L8.95901921,13.2378076 C11.7212544,12.8335998 14.0116959,10.4588786 14.0116959,7.57889751 L12.5802094,7.57889751 Z",
    id: "Path_197",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "icon/record/gray/2",
    transform: "translate(9.000000, 20.000000)",
    filter: "url(#filter-2)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0,5.26457572 L0,10.7378188 L3.55563915,10.7378188 L7.99993809,15.2987407 L7.99993809,0.70331174 L3.55563915,5.26457572 L0,5.26457572 Z M11.9999095,8.00119727 C11.9995473,6.44209251 11.1385555,5.01778041 9.777591,4.32488829 L9.777591,11.6682702 C11.1394491,10.9811541 12.0015649,9.55856571 11.9999095,8.00119727 Z M9.777591,0.00102623308 L9.777591,1.88005901 C12.414845,2.68758365 14.2222649,5.17666577 14.2222649,8.00102623 C14.2222649,10.8253867 12.414845,13.3144688 9.777591,14.1219935 L9.777591,16 C13.4172116,15.151025 16,11.8303968 16,8 C16,4.16960323 13.4172116,0.848974957 9.777591,0 L9.777591,0.00102623308 Z",
    id: "Path_387",
    fill: "#009D92",
    fillRule: "nonzero"
  }))), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#4FB3BF",
    strokeWidth: 2,
    cx: 17,
    cy: 28,
    r: 16
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#00838F",
    strokeWidth: 2,
    cx: 263,
    cy: 28,
    r: 16
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80,26 C81.1045695,26 82,26.8954305 82,28 C82,29.1045695 81.1045695,30 80,30 C78.8954305,30 78,29.1045695 78,28 C78,26.8954305 78.8954305,26 80,26 Z M92,26 C93.1045695,26 94,26.8954305 94,28 C94,29.1045695 93.1045695,30 92,30 C90.8954305,30 90,29.1045695 90,28 C90,26.8954305 90.8954305,26 92,26 Z M104,26 C105.104569,26 106,26.8954305 106,28 C106,29.1045695 105.104569,30 104,30 C102.895431,30 102,29.1045695 102,28 C102,26.8954305 102.895431,26 104,26 Z M116,26 C117.104569,26 118,26.8954305 118,28 C118,29.1045695 117.104569,30 116,30 C114.895431,30 114,29.1045695 114,28 C114,26.8954305 114.895431,26 116,26 Z M68,26 C69.1045695,26 70,26.8954305 70,28 C70,29.1045695 69.1045695,30 68,30 C66.8954305,30 66,29.1045695 66,28 C66,26.8954305 66.8954305,26 68,26 Z M56,26 C57.1045695,26 58,26.8954305 58,28 C58,29.1045695 57.1045695,30 56,30 C54.8954305,30 54,29.1045695 54,28 C54,26.8954305 54.8954305,26 56,26 Z M44,26 C45.1045695,26 46,26.8954305 46,28 C46,29.1045695 45.1045695,30 44,30 C42.8954305,30 42,29.1045695 42,28 C42,26.8954305 42.8954305,26 44,26 Z M200,26 C201.104569,26 202,26.8954305 202,28 C202,29.1045695 201.104569,30 200,30 C198.895431,30 198,29.1045695 198,28 C198,26.8954305 198.895431,26 200,26 Z M212,26 C213.104569,26 214,26.8954305 214,28 C214,29.1045695 213.104569,30 212,30 C210.895431,30 210,29.1045695 210,28 C210,26.8954305 210.895431,26 212,26 Z M224,26 C225.104569,26 226,26.8954305 226,28 C226,29.1045695 225.104569,30 224,30 C222.895431,30 222,29.1045695 222,28 C222,26.8954305 222.895431,26 224,26 Z M236,26 C237.104569,26 238,26.8954305 238,28 C238,29.1045695 237.104569,30 236,30 C234.895431,30 234,29.1045695 234,28 C234,26.8954305 234.895431,26 236,26 Z M188,26 C189.104569,26 190,26.8954305 190,28 C190,29.1045695 189.104569,30 188,30 C186.895431,30 186,29.1045695 186,28 C186,26.8954305 186.895431,26 188,26 Z M176,26 C177.104569,26 178,26.8954305 178,28 C178,29.1045695 177.104569,30 176,30 C174.895431,30 174,29.1045695 174,28 C174,26.8954305 174.895431,26 176,26 Z M164,26 C165.104569,26 166,26.8954305 166,28 C166,29.1045695 165.104569,30 164,30 C162.895431,30 162,29.1045695 162,28 C162,26.8954305 162.895431,26 164,26 Z",
    id: "Combined-Shape",
    fill: "url(#linearGradient-3)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Oval"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-4)",
    fillRule: "evenodd",
    xlinkHref: "#path-6"
  }), /*#__PURE__*/React.createElement("circle", {
    stroke: "url(#linearGradient-5)",
    strokeWidth: 2,
    cx: 140,
    cy: 28,
    r: 13
  }), /*#__PURE__*/React.createElement("circle", {
    stroke: "#FFFFFF",
    strokeWidth: 2,
    strokeLinejoin: "square",
    cx: 140,
    cy: 28,
    r: 11
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgLatency, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/latency.c8d3e001.svg";
export { ForwardRef as ReactComponent };